import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatThingAttribute',
  pure: true
})
export class formatThingAttributePipe implements PipeTransform {
  transform(value: any, type: string): string {
    if (value == null || typeof value == 'undefined' || value === '' || ! type) {
      return 'Unknown';
    }

    if (type === 'dropdown' || type === 'number') {
      return value;
    } else if (type === 'checkbox') {
      return !! value ? 'Yes' : 'No';
    }
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/attributes/formatAttribute.pipe.ts